import { getAxiosInstance } from './axiosInstance';
const getAllModels = () => {
  const http = getAxiosInstance();
  return http.get("/api/devicemodel/devicemodelList/");
};
const getFilterModels = (data) => {
  const http = getAxiosInstance();
  return http.post('/api/devicemodel/devicemodelFilter/', data)
}
const getFilterModelsdata = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/devicemodel/devicemodelFilter/",
    data
  );
};
const getAdminAwaitingModels = () => {
  const http = getAxiosInstance();
  return http.get("/api/devicemodel/devicemodelAwaitingStateApproval/");
};
const getAdminAwaitingCOPModels = () => {
  const http = getAxiosInstance();
  return http.get("/api/devicemodel/COPAwaitingStateApproval/");
};
const getModel = (id) => {
  const http = getAxiosInstance();
  return http.post(`api/devicemodel/devicemodelDetails/`, id);
};
const createModel = (data) => {
  const http = getAxiosInstance();
  return http.post("/api/devicemodel/devicemodelCreate/", data, {
    headers: {
      'Content-type': 'multipart/form-data',
    }
  });
};
const copUpload = (data) => {
  const http = getAxiosInstance();
  return http.post("/api/devicemodel/COPUpload/", data, {
    headers: {
      'Content-type': 'multipart/form-data',
    }
  })
}
const updateModel = (id, updatedData) => {
  const http = getAxiosInstance();
  return http.put(`/api/update_device_model/${id}`, updatedData);
};
const deleteModel = (id) => {
  const http = getAxiosInstance();
  return http.delete(`/api/delete_device_model/${id}`);
};
const getDeviceList = (data) => {
  const http = getAxiosInstance();         // show device
  return http.post("/api/devicestock/deviceStockFilter/", data)
}
const stateadminApprovedModels = (data) => {
  const http = getAxiosInstance();
  return http.post('/api/stateadmin/reports/approved-models/', data)
}

const stateadminApprovedCOPModels = (data) => {
  const http = getAxiosInstance();
  return http.post('/api/stateadmin/reports/approved-cops/', data)
}

const createTechnicalOnboardingRequest = (formData) => {
  const http = getAxiosInstance();
  return http.post("/api/devicemodel/technical-onboarding/create/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const listManufacturerTechnicalOnboardingRequests = (data = {}) => {
  const http = getAxiosInstance();
  return http.post("/api/devicemodel/technical-onboarding/manufacturer/list/", data);
};

const listSuperadminTechnicalOnboardingRequests = (data = {}) => {
  const http = getAxiosInstance();
  return http.post("/api/devicemodel/technical-onboarding/superadmin/list/", data);
};

const markTechnicalOnboardingOngoing = (data) => {
  const http = getAxiosInstance();
  return http.post("/api/devicemodel/technical-onboarding/superadmin/mark-ongoing/", data);
};

const finalizeTechnicalOnboardingRequest = (formData) => {
  const http = getAxiosInstance();
  return http.post("/api/devicemodel/technical-onboarding/superadmin/finalize/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const DeviceModelServices = {
  getAllModels,
  getAdminAwaitingModels,
  getAdminAwaitingCOPModels,
  getModel,
  createModel,
  updateModel,
  copUpload,
  deleteModel,
  getDeviceList,
  getFilterModels,
  getFilterModelsdata,
  stateadminApprovedModels,
  stateadminApprovedCOPModels,
  createTechnicalOnboardingRequest,
  listManufacturerTechnicalOnboardingRequests,
  listSuperadminTechnicalOnboardingRequests,
  markTechnicalOnboardingOngoing,
  finalizeTechnicalOnboardingRequest,
};

export default DeviceModelServices;
